export default __webpack_public_path__ + "static/media/compose_logo_light_half.7bbf3288.svg";